import { device } from '@/components/templates/displays/devices'
import { motion } from 'framer-motion'
import * as React from 'react'
import styled from 'styled-components'
import BannerViewIcon from '../statefullIcons/BannerViewIcon'
import GridViewIcon from '../statefullIcons/GridViewIcon'

interface IStyle {}

const Button = styled(motion.div)<IStyle>`
    display: flex;
    justify-content: center;
    align-items: center;
    padding-top: 5px;
    padding-bottom: 5px;
    padding-left: 25px;
    padding-right: 25px;
    border: 1px solid #98c9ca;
    outline: none;
    background-color: #f7fafa;
    border-radius: 5px;
    transition: all 200ms;
    cursor: pointer;
    :hover {
        box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.09);
        transition: all 200ms;
    }
`

const Line = styled.div`
    @media ${device.beyond_ipad_mobile} {
        height: 34px;
        width: 1px;
        background-color: #ececec;
        margin-left: 14px;
        margin-right: 14px;
    }

    @media ${device.mobile} {
    }
`

type Props = {
    setGridView: any
    setBannerView: any
    activeView: 'grid_view' | 'banner_view'
}

const ViewsMenuDesktop: React.FunctionComponent<Props> = (props) => {
    let { setBannerView, setGridView, activeView } = props
    return (
        <Button>
            <div data-attr="banner_view_desktop">
                <GridViewIcon
                    onClick={(e: any) => {
                        e.preventDefault(e)
                        setGridView()
                    }}
                    isActive={activeView === 'grid_view' ? true : false}
                    data-attr="grid_view_desktop"
                />
            </div>
            <Line />
            <div data-attr="banner_view_desktop">
                <BannerViewIcon
                    onClick={(e: any) => {
                        e.preventDefault(e)
                        setBannerView()
                    }}
                    isActive={activeView === 'banner_view' ? true : false}
                />
            </div>
        </Button>
    )
}

export default ViewsMenuDesktop
